import React from 'react'

function Orders() {
  return (
    <div>
      Orders
    </div>
  )
}

export default Orders
